import { render, staticRenderFns } from "./galerie.vue?vue&type=template&id=305a24a7&scoped=true&"
import script from "./galerie.vue?vue&type=script&lang=js&"
export * from "./galerie.vue?vue&type=script&lang=js&"
import style0 from "./galerie.vue?vue&type=style&index=0&id=305a24a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305a24a7",
  null
  
)

export default component.exports